
// Import the native module. On web, it will be resolved to ExpoIncodeSdkConfiguration.web.ts
// and on native platforms to ExpoIncodeSdkConfiguration.ts
import ExpoIncodeSdkConfigurationModule from './ExpoIncodeSdkConfigurationModule';
